import { Input } from '../../../components/core/Input';
import { useForm } from 'react-hook-form';
import { useModal } from '../../../hooks/useModal';
import Select from '../../../components/others/Select/Select';
import { InputEmail } from '../../../components/others/InputEmail';
import { useEffect, useState } from 'react';
import { InputNumber } from '../../../components/others/InputNumber';
import LavorisService from '../../../services/LavorisService';
import { PrimaryButton } from '../../../components/others/ButtonPrimary';
import { useNavigate } from 'react-router-dom';
import { individualEntities } from '../../../services/publicData/PublicData.type';
import { FormPreValues } from './AddCompany.type';
import { ModalCheckEmail } from '../modalCheckEmail';
import { PhoneNumber } from '../../../components/others/PhoneNumber';
import SelectProvincias from '../../../components/others/SelectProvincias/SelectProvincias';
import { CircularProgress } from '@mui/material';
import Textarea from '../../../components/others/Textarea/Textarea';
import { useAlert } from '../../../hooks/useAlert';
import { getErrorMessage } from '../../../utils/ErrorHandlers';
import InputRadio from '../../../components/others/InputRadio/InputRadio';
import FileUpload from '../../../components/others/FileUploader/FileUploader';
import DynamicFileUpload from '../../../components/others/DynamicFileUpload';
import GradingIcon from '@mui/icons-material/Grading';
import InputCheckbox from '../../../components/others/InputCheckbox/InputCheckbox';

const EMAIL_CHECKER = 'emailChecker';
const TERMS_AND_CONDITIONS_URL = 'https://drive.google.com/file/d/1QsNMjvrop_U-3G4_jzjxxR7UF3DsX3-q/view?usp=sharing';
interface selectedFiles {
  profileImages?: File[];
}
export default function AddCompany() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    reset
  } = useForm<FormPreValues>({
    mode: 'all',
    defaultValues: {
      billingWebPortalEnabled: 'No',
      purchaseOrderRequired: 'No',
      company: {
        billing_web_url: null,
        purchase_order: null,
        accepted_terms_and_conditions: false,
      },
    },
  });
  const [isReady, setIsReady] = useState(false);
  const { openModal, isActive } = useModal();
  const { showAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const [registerError, setRegisterError] = useState(false);
  const [province, setProvince] = useState('');
  const LavorisInstance = LavorisService.getInstance();
  let navigate = useNavigate();
  const [selectedFiles, setSelectedFiles] = useState<selectedFiles | null>(
    null,
  );
  const [extraFiles, setExtraFiles] = useState<File[]>([]);
  const adminMail = watch('admin.email') || '';
  const billingWebPortalEnabled = watch('billingWebPortalEnabled');
  const purchaseOrderRequired = watch('purchaseOrderRequired');
  const accepted_terms_and_conditions = watch('company.accepted_terms_and_conditions');


  const buttonStyles = `font-bold text-[#FFFFFF] border-[#fb554f]  rounded-md  h-12 w-100 py-2 ${isLoading ? 'bg-[#fb544f]' : 'bg-[#fb554f]'}`;
  const onCancel = () => {
    navigate('/');
  };

  const [ivaConditionsValues, setivaConditionsValues] =
    useState<individualEntities>([
      {
        name: '',
        value: ''
      }
    ]);
  const [rubroCompanyValues, setrubroCompanyValues] =
    useState<individualEntities>([
      {
        name: '',
        value: ''
      }
    ]);

  const [fetchARTs, setARTs] = useState<individualEntities>([
    {
      name: '',
      value: ''
    }
  ]);

  const companyEmployeeRange = [
    {
      name: '1 a 50 empleados',
      value: '1-50',
    },
    {
      name: '51 a 200 empleados',
      value: '51-200',
    },
    {
      name: '201 a 500 empleados',
      value: '201-500'
    },
    {
      name: 'Más de 500 empleados',
      value: '500_PLUS'
    }
  ];

  const dataPublic = async () => {
    try {
      const publicData = await LavorisInstance.PublicData.getPublicData();
      if (publicData) {
        setrubroCompanyValues(publicData.rubroCompany);
        setivaConditionsValues(publicData.ivaConditions);
        setARTs(publicData.arts);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const handleSelect = (selectedValue: any) => {
    setProvince(selectedValue);
  };

  useEffect(() => {
    const getData = async () => {
      await dataPublic();
      reset();
      setIsReady(true);
    };
    getData();
  }, []);

  const onSubmit = async (data: FormPreValues) => {
   setIsLoading(true);
    setRegisterError(false);
    const fullName = `${data?.admin?.lastName?.trim()}, ${data?.admin?.firstName?.trim()}`;
    const mergedFiles: File[] = [
      ...(selectedFiles?.profileImages ?? []),
      ...extraFiles,
    ];

    const mappedData = {
      admin: {
        email: data?.admin?.email,
        billingEmailEnabled: true,
        name: fullName.trim(),
        phoneNumber: data?.admin?.admin_phoneNumber,
      },
      company: {
        ...data.company,
        province: province,
        cuit: +data.company.cuit,
        billing_web_url: data.billingWebPortalEnabled === 'Si' ? data.company.billing_web_url : null,
        purchase_order: data.purchaseOrderRequired === 'Si' ? data.company.purchase_order : null,
      }
    };
    if (!selectedFiles || !selectedFiles?.profileImages) {
      alert('Por favor, complete el campo de Constancia de AFIP');
      setIsLoading(false);
      return;
    }  
   
    try {
      const companyCreated = await LavorisInstance.CompanyServices.addCompany(mappedData);      
      if (companyCreated?.id) {
        await uploadFile(companyCreated?.id, { profileImages: mergedFiles });
      }
      openModal(EMAIL_CHECKER);
    } catch (err: any) {
      console.log(err);
      showAlert(getErrorMessage({ title: 'Error al crear la compañia', err }));
      setRegisterError(true);
    } finally {
      setIsLoading(false);
    }
  };
  ///Funciones para la carga de archivos

  const updateUploadedFiles = (files: File[]) => {
    const updatedSelectedFiles: selectedFiles = { ...(selectedFiles ?? {}) };

    if (files.length > 0) {

      if (updatedSelectedFiles.profileImages) {
        updatedSelectedFiles.profileImages = [...updatedSelectedFiles.profileImages, ...files];
      } else {
        updatedSelectedFiles.profileImages = files;
      }
    }

    setSelectedFiles(updatedSelectedFiles);
  };

  // Para DynamicFileUpload: recibe la lista consolidada y la reemplaza (permite eliminar sin duplicar)
  const updateExtraFiles = (files: File[]) => {
    setExtraFiles(files);
  };

  const uploadFile = async (id: any, selectedFile: any) => {
    await LavorisInstance.CompanyServices.addFileRegister(
      { file: selectedFile },
      id,
    ).catch((e: any) => console.log(e));
  };
  if (!isReady) return <CircularProgress color="error" size={15} />;
  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="grid w-full gap-6 grid-flow rows"
      >
        <h6 className="subtitle">Datos de la empresa</h6>
        <Input
          type="text"
          label="Razón social *"
          fieldName="company.socialReason"
          register={register}
          required
          error={errors?.company?.socialReason}
        />
        <Input
          type="text"
          label="Nombre de fantasía *"
          fieldName="company.fantasyName"
          register={register}
          required
          error={errors?.company?.fantasyName}
        />
        <InputNumber
          label="CUIT - sin espacios ni guiones - *"
          nameInput="company.cuit"
          register={register}
          required
          error={errors}
        />
        <Select
          fieldName="company.ivaCondition"
          label="Condición frente al IVA *"
          options={ivaConditionsValues}
          register={register}
          required
          error={errors?.company?.ivaCondition}
          styles="rounded w-full h-[50px]"
        />
        <Select
          fieldName="company.heading"
          label="Rubro de la empresa *"
          options={rubroCompanyValues}
          register={register}
          required
          error={errors?.company?.heading}
          styles="rounded w-full h-[50px]"
        />
        <Select
          fieldName="company.ART"
          styles="w-full rounded-md h-12"
          register={register}
          label={'ART *'}
          required={true}
          error={errors?.company?.ART}
          options={fetchARTs}
        />
        <Select
          fieldName="company.employeeRange"
          styles="w-full rounded-md h-12"
          register={register}
          label={'Cantidad de empleados *'}
          required={true}
          error={errors?.company?.employeeRange}
          options={companyEmployeeRange}
        />
        <h6 className="subtitle">
          Información de contacto
        </h6>

        <SelectProvincias onSelect={handleSelect} defaultValue={province} />

        <Input
          type="text"
          label="Localidad o Barrio *"
          fieldName="company.location"
          register={register}
          required
          error={errors?.company?.residence}
        />
        <Input
          type="text"
          label="Dirección *"
          fieldName="company.residence"
          register={register}
          required
          error={errors?.company?.residence}
        />

        <Input
          type="text"
          label="Código postal *"
          fieldName="company.postalCode"
          register={register}
          required
          error={errors?.company?.postalCode}
        />

        <PhoneNumber
          label="Teléfono"
          fieldName="company.phoneNumber"
          control={control}
          error={errors?.company?.phoneNumber}
          required
        />
        <Input
          type="email"
          label="Email de la compañía (opcional)"
          fieldName="company.email"
          register={register}
          error={errors?.company?.email}
        />

        <Input
          type="text"
          label="Website (opcional)"
          fieldName="company.web"
          register={register}
        />
        <small className='className="w-full bg-[#F5F5F5] border-[md]'>*Subir archivos con el nombre "Constancia de AFIP" según corresponda.</small>
        <FileUpload
          label="Cargar Constancia de AFIP"
          updateFilesCb={updateUploadedFiles}
          maxFileSizeInBytes={1000000}
          accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          multiple
        />

        {/* <FileUpload
          label="Cargar Constancia de IIBB"
          updateFilesCb={updateUploadedFiles}
          maxFileSizeInBytes={1000000}
          accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          multiple
        /> */}
        <DynamicFileUpload
          label="Otro archivo (opcional)"
          updateFilesCb={updateExtraFiles}
          maxFileSizeInBytes={1000000}
          accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          multiple
          buttonText="Agregar otro archivo"
        />
        <h6 className="subtitle">
          Datos de facturación
        </h6>
        <InputRadio
          label="¿Dispone de un portal web para la carga y gestión de facturas? *"
          fieldName="billingWebPortalEnabled"
          option1="Si"
          option2="No"
          register={register}
          defaultValue="No"
          required
          error={errors?.billingWebPortalEnabled}
          inputsContainerStyles="flex justify-around w-full"
          labelStyles="w-full"
        />

        {billingWebPortalEnabled === 'Si' && (
          <Input
            type="text"
            label="Indique la página WEB *"
            fieldName="company.billing_web_url"
            register={register}
            required
            error={errors?.company?.billing_web_url}
          />
        )}

        <InputRadio
          label="¿Previo a la facturación, necesita Orden de compra o Nota de pedido? *"
          fieldName="purchaseOrderRequired"
          option1="Si"
          option2="No"
          register={register}
          defaultValue="No"
          required
          error={errors?.purchaseOrderRequired}
          inputsContainerStyles="flex justify-around w-full"
          labelStyles="w-full"
        />

        {purchaseOrderRequired === 'Si' && (
          <Textarea
            register={register}
            fieldName="company.purchase_order"
            label="Indique el procedimiento *"
            required
            error={errors?.company?.purchase_order}
            rows={4}
            styles="rounded w-full"
          />
        )}

        <Input
          type="Temail"
          label="E-mail de cuentas a Pagar *"
          fieldName="company.account_payable_email"
          register={register}
          required
          error={errors?.company?.account_payable_email}
        />

        <h6 className="subtitle">
          Datos del administrador
        </h6>

        <Input
          type="text"
          label="Apellido del administrador *"
          fieldName="admin.lastName"
          register={register}
          error={errors?.admin?.lastName}
          required={true}
        />
        <Input
          type="text"
          label="Nombre del administrador *"
          fieldName="admin.firstName"
          register={register}
          error={errors?.admin?.firstName}
          required={true}
        />


        <InputEmail
          label="E-mail del administrador *"
          nameInput="admin.email"
          register={register}
          required
          error={errors}
        />

        <PhoneNumber
          label="Teléfono del administrador *"
          fieldName="admin.admin_phoneNumber"
          control={control}
          error={errors?.admin?.admin_phoneNumber}
          required
        />

        <small className='className="w-full bg-[#F5F5F5] border-[md]'>*Se enviará un mail a esta dirección para verificar la cuenta.</small>

        <small className='w-full bg-[#F5F5F5] border-[md]'>**Este mismo e-mail se utilizará para el envío de las facturas electrónicas.</small>

        <small className='w-full bg-[#F5F5F5] border-[md]'>***Una vez aprobada la cuenta, se podrá agregar más mails de facturación en el perfil de la compañía en Personas de Contactos</small>

        <Textarea
          register={register}
          fieldName="company.comments"
          label="Comentarios"
          error={errors?.company?.comments}
          rows={4}
          styles="rounded w-full"
        />
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <GradingIcon className="text-[#fb544f]" />
            <a
              href={TERMS_AND_CONDITIONS_URL}
              target="_blank"
              rel="noopener noreferrer"
              title="Conocé nuestros Términos y condiciones"
              className="underline text-[#fb544f]"
            >
              Conocé nuestros Términos y Condiciones
            </a>
          </div>
          <InputCheckbox
            register={register}
            fieldName="company.accepted_terms_and_conditions"
            required
            error={errors?.company?.accepted_terms_and_conditions}
            label="*Al continuar, declaro haber leído y aceptado los términos y condiciones."
          />
        </div>
        <div className="w-100">
          <PrimaryButton
            type="submit"
            text="Solicitar cuenta"
            styles={`font-bold text-[#FFFFFF] border-[#fb554f]  rounded-md  h-12 w-100 py-2 ${accepted_terms_and_conditions ? 'bg-[#fb554f]' : 'bg-gray-500'}`}
            disabled={isLoading}
          />
        </div>

        <small>(*) Campos obligatorios</small>

        {registerError && (
          <small className="flex w-full mt-2 justify-center text-center text-red-500">
            {`No se pudo crear a la compañia, intente nuevamente más tarde
              Si sigue asi consulte con Lavoris.`}
          </small>
        )}
      </form>

      {isActive(EMAIL_CHECKER) && (
        <ModalCheckEmail urlTittle={EMAIL_CHECKER} mail={adminMail} show />
      )}
    </>
  );
}
